<app-landing-navbar></app-landing-navbar>

<main class="forgot-password-page">
  <section class="forgot-password-layout">
    <div class="forgot-password-art" aria-hidden="true">
      <div class="auth-art-shell">
        <h2 class="auth-art-headline auth-scroll-reveal">
          Simplifies And Automates Vendor Interactions With Government
          Organizations.
        </h2>

        <div class="auth-art-scene auth-scroll-reveal">
          <img
            class="auth-art-image auth-art-image--dashboard auth-animate-float"
            src="assets/svgs/dashboard.svg"
            alt=""
          />
          <img
            class="auth-art-image auth-art-image--bar-chart auth-animate-float-delayed"
            src="assets/svgs/bar-chart.svg"
            alt=""
          />
          <img
            class="auth-art-image auth-art-image--chart auth-animate-float-slow"
            src="assets/svgs/chart.svg"
            alt=""
          />
        </div>

        <p class="auth-art-caption auth-scroll-reveal">
          Everything the vendor lifecycle needs, in one coordinated system.
        </p>
      </div>
    </div>

    <div class="forgot-password-panel">
      <div class="forgot-password-card">
        <div class="forgot-password-brand">
          <div class="forgot-password-brand__mark">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <circle cx="12" cy="5" r="1.5" fill="currentColor"></circle>
              <circle cx="12" cy="19" r="1.5" fill="currentColor"></circle>
              <circle cx="5" cy="12" r="1.5" fill="currentColor"></circle>
              <circle cx="19" cy="12" r="1.5" fill="currentColor"></circle>
              <line x1="12" y1="6.5" x2="12" y2="9"></line>
              <line x1="12" y1="15" x2="12" y2="17.5"></line>
              <line x1="6.5" y1="12" x2="9" y2="12"></line>
              <line x1="15" y1="12" x2="17.5" y2="12"></line>
            </svg>
          </div>
          <div class="forgot-password-brand__text">
            <span class="forgot-password-brand__title">VMS</span>
            <span class="forgot-password-brand__caption"
              >Vendor Management System</span
            >
          </div>
        </div>

        <div class="forgot-password-copy">
          <h1>Forgot Password</h1>
          <p>
            Enter the email attached to your vendor account and we will send a
            reset link.
          </p>
        </div>

        <form
          class="forgot-password-form"
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="submit()"
        >
          <label class="forgot-password-field">
            <span class="forgot-password-field__label"
              >Enter Email Address</span
            >
            <span class="forgot-password-row">
              <span
                class="forgot-password-input"
                [class.forgot-password-input--invalid]="emailControl.invalid && (emailControl.touched || emailControl.dirty)"
              >
                <svg
                  class="forgot-password-input__icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6h16v12H4z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m4 8 8 6 8-6"
                  ></path>
                </svg>
                <input
                  type="email"
                  formControlName="email"
                  placeholder="example@gmail.com"
                  autocomplete="email"
                  [attr.aria-invalid]="emailControl.invalid && (emailControl.touched || emailControl.dirty)"
                  [disabled]="isSubmitting"
                />
              </span>
              <button
                type="submit"
                class="forgot-password-submit"
                [disabled]="!canSubmit"
              >
                {{ isSubmitting ? 'Sending...' : 'Send Email' }}
              </button>
            </span>
            @if (emailErrorMessage) {
            <span class="forgot-password-field__error"
              >{{ emailErrorMessage }}</span
            >
            }
          </label>

          <p class="forgot-password-note">
            We will email a secure reset link if the address matches an active
            account.
          </p>

          <p class="forgot-password-footer">
            Remember your password?
            <a routerLink="/login">Back to Sign In</a>
          </p>
        </form>
      </div>
    </div>
  </section>
</main>

@if (isSuccessModalOpen) {
<div class="forgot-password-modal" role="dialog" aria-modal="true">
  <div
    class="forgot-password-modal__backdrop"
    (click)="closeSuccessModal()"
  ></div>
  <div class="forgot-password-modal__card">
    <div class="forgot-password-modal__icon">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="m8.5 12.5 2.3 2.3 4.7-5.3"></path>
      </svg>
    </div>
    <h2>Email Sent</h2>
    <p>{{ successMessage }}</p>
    <button
      type="button"
      class="forgot-password-modal__button"
      (click)="closeSuccessModal()"
    >
      Back to Sign In
    </button>
  </div>
</div>
}
